import React, { useEffect, useState } from 'react';
import DataGridComponent from 'Utils/Helpers/DataGridComponent';
import { patientList } from 'Utils/Helpers/TableColumns';
import { useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import Pagination from '@mui/material/Pagination';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { getPatients } from 'http/components/PatientService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { enqueueSnackbar } from 'notistack';

export default function PatientList({ reset, doReset}) {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [pagin, setPagin] = useState({});
    const [searchValue, setSearchValue] = useState({ data: '', page: 1, limit: 5 });
    
    const [controls, setControls] = useSetState ({
        search: {
          id: "search",
          type: 'text',
          placeholder: 'جستجو کنید...',
          value: '',
          icon: <icons.ListTask/>,
        },
    });

    useEffect(() => {
        if(reset) {
            setSearchValue({ ...searchValue, data: '', page: 1})
            setControls({ search: { value: '' } });
            setData([]);
            setPagin({});
            doReset();
        }
    }, [reset])

    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }

    useEffect(() => {
        if(searchValue.data !== '') getData(searchValue)
    }, [searchValue])

    const onPageChange = async (event, newPage) => {
        if(pagin.page !== newPage) {
            setSearchValue({ ...searchValue, page: newPage })
        } else {
            enqueueSnackbar('هم اکنون در همین صفحه هستید', {variant: 'info'});
        }
    }

    const onSearch = async () => {
        if(controls.search.value !== '') {
            setSearchValue({ ...searchValue, data: controls.search.value, page: 1 })
        } else {
            enqueueSnackbar('عبارتی برای جستجو وارد کنید', {variant: 'warning'});
        }
    }

    const getData = async (data) => {
        const response = await getPatients(data);
        dispatch(HandleLoading(true));
        if(response.status) {
            if(response.data.patients.length === 0 ) {
                enqueueSnackbar('بیماری با این خصوصیت یافت نشد', {variant: 'warning'});
            } else {
                setSelectionModel([response.data.patients[0].id]);
            }
            setData(response.data.patients);
            setPagin(response.data.pagination);
            dispatch(HandleLoading(false));
        } else {
            enqueueSnackbar('بروز خطا در زمان بارگزاری بیماران', {variant: 'error'});
            dispatch(HandleLoading(false));
        }
    }

    return (
        <>
            <div className='search-patient-dialog'>
                {
                    !reset && Object.keys(controls).map((key, index) => {
                    return (
                        <Inputer
                            key={`inputer_${controls[key].id}`}
                            id={controls[key].id}
                            type={controls[key].type}
                            placeholder={controls[key].placeholder}
                            value={controls[key].value}
                            setValue={setControlsValue.bind(this)}
                            icon={controls[key].icon}
                            onKeyEnterActive={true}
                            onKeyEnter={onSearch}
                            className={'text-search-box'}
                        />
                    )
                    })
                }
                <CButton
                    icon={<icons.Search/>}
                    onClick={onSearch}
                    className={'btn-search'}
                />
            </div>
            <div className='text-center'>
                {
                    (data && data.length !== 0)
                    ? <>
                        {
                            (pagin.totalPages !== 1) &&
                            <div className='p-1 mb-1 felx-row-center-center border rounded-3 ' dir='ltr'>
                                <Pagination
                                    count={pagin.totalPages}
                                    page={pagin.page}
                                    shape="rounded"
                                    size="small"
                                    onChange={onPageChange}
                                    hidePrevButton
                                    hideNextButton
                                />
                            </div>
                        }
                        <div className="w-100">
                            <DataGridComponent
                                data={data}
                                columns={patientList}
                                selectionModel={selectionModel}
                                onSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                }}
                            />
                        </div>
                    </> : <div className='flex-column-center-center'>
                            <small className='mb-1'>{"اطلاعاتی برای نمایش موجود نمی‌باشد"}</small>
                            <small>{"خصوصیتی از بیمار را جستجو کنید"}</small>
                        </div>
                }
            </div>
        </>
    );
}